import { isBlockedAnalyticsPath, isMedicalGuide, MEDICAL_GUIDE_PATH } from "./analyticsPaths";
import { trackPlatformEvent } from "./platformAnalytics";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let loaded = false;
let lastTrackedPath = "";

const PLATFORM_EVENT_ALIASES = {
  event_card_click: "event_click",
  event_source_click: "event_click",
};

const PLATFORM_EVENT_NAMES = new Set([
  "venue_card_click",
  "directions_click",
  "phone_click",
  "website_click",
  "menu_click",
  "share_click",
  "event_click",
  "event_card_click",
  "event_source_click",
  "claim_listing_click",
]);

function isQrResolverPath(pathname) {
  return pathname === "/go" || pathname.startsWith("/go/");
}

function trackPlatformConversionEvent(eventName, params = {}) {
  if (!PLATFORM_EVENT_NAMES.has(eventName)) return;

  const platformEventName = PLATFORM_EVENT_ALIASES[eventName] || eventName;
  const destinationUrl = params.destination_url || params.href || null;

  void trackPlatformEvent(platformEventName, {
    venue_id: params.venue_id || null,
    venue_name: params.venue_name || null,
    venue_slug: params.venue_slug || null,
    category: params.category || null,
    city: params.city || null,
    page_path: params.page_path || `${window.location.pathname}${window.location.search || ""}`,
    metadata_json: {
      source_event: eventName,
      destination_url: destinationUrl,
      source_section: params.source_section || null,
      venue_slug: params.venue_slug || null,
      event_id: params.event_id || null,
      event_title: params.event_title || null,
    },
  });
}

export function initGA() {
  if (!GA_ID || loaded || typeof window === "undefined") return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    send_page_view: false,
  });

  loaded = true;
}

export function trackPageView(pathname, search = "") {
  if (!GA_ID || typeof window === "undefined") return;
  if (isBlockedAnalyticsPath(pathname) || isQrResolverPath(pathname)) return;

  initGA();

  const medical = isMedicalGuide(pathname);
  const pagePath = medical ? MEDICAL_GUIDE_PATH : `${pathname}${search || ""}`;
  if (pagePath === lastTrackedPath) return;

  lastTrackedPath = pagePath;

  window.gtag?.("event", "page_view", {
    page_title: medical ? "Medical help in Benalmádena" : document.title,
    ...(medical ? { page_referrer: "" } : {}),
    page_location: `${window.location.origin}${pagePath}`,
    page_path: pagePath,
  });
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;

  const pathname = window.location.pathname;
  if (isBlockedAnalyticsPath(pathname)) return;

  const medical = isMedicalGuide(pathname);
  trackPlatformConversionEvent(eventName, medical ? { page_path: MEDICAL_GUIDE_PATH } : params);

  if (!GA_ID) return;

  initGA();

  window.gtag?.("event", eventName, medical ? {
    page_path: MEDICAL_GUIDE_PATH,
    page_location: window.location.origin + MEDICAL_GUIDE_PATH,
    page_referrer: "",
    page_title: "Medical help in Benalmádena",
  } : {
    page_path: `${pathname}${window.location.search || ""}`,
    ...params,
  });
}
